import StandingsBase from "./StandingsBase";

export default function StandingsTeam() {
    return (
        <StandingsBase
            scopeType="TEAM"
            classKey=""
            heading="Meisterschaftswertung"
            pillLabel="TEAM"
        />
    );
}
